import { DI } from '@intigral/constant/config/DIContainer';
import { ITpayRedirectSubscribeNewUseCase } from '../../core/usecases/subscription/TpayRedirectSubscribeNewUseCase';
import { container } from '../../DataDomain';
import {
    ITpayPayload,
    ITpayRedirectSubscribeExistingUserEntity,
    ITpayRedirectSubscribeExistingUserReqBody,
    ITpayRedirectSubscribeNewUserEntity,
    ITpayRedirectSubscribeNewUserReqBody,
} from '../../entity/interface/iTPayRedirectSubscribe';
import { ITpayRedirectSubscribeExistingUseCase } from '../../core/usecases/subscription/TpayRedirectSubscribeExistingUseCase';
import { IUnsubscribeEntity, IUnsubscribeReqBody } from '../../entity';
import { IUnsubscribeUseCase } from '../../core/usecases/subscription/UnsubscribeUseCase';
import { ISubscriptionStatus } from '../../entity/interface/iSubscriptionStatus';
import {
    CampaignGenerateResponse,
    IBoltSubscriptionRequest,
    IBoltSubscriptionResponse,
    IBoltSubscriptionTwoStepsRequest,
    IBoltSubscriptionTwoStepsResponse,
    IBoltVerifyTwoStepsRequest,
    IBoltVerifyTwoStepsResponse,
    ICampaignVerifyResponse,
    ICheckUserRequest,
    ICheckUserResponse,
    IUserRegisterGeneratePin,
    IUserRegisterRequest,
    IUserRegisterVerifyPin,
    IValidateActivationLinkRequest,
    IValidateActivationLinkResponse,
    IDisneyGenerateOtpRequest,
    IDisneyGenerateOtpResponse,
    IDisneyValidateOtpRequest,
    IDisneyValidateOtpResponse,
    IDisneyRequestActivationLinkRequest,
    IDisneyRequestActivationLinkResponse,
    IPartnerActivationRedirectionRequest,
    IPartnerActivationRedirectionResponse,
} from '../../entity/interface/iSubscription';
import { IBoltUserSubscriptionUseCase } from '../../core/usecases/subscription/BoltUserSubscriptionUseCase';
import { IBoltUserSubscriptionTwoStepsUseCase } from '../../core/usecases/subscription/BoltUserSubscriptionTwoStepsUseCase';
import { IBoltUserVerificationTwoStepsUseCase } from '../../core/usecases/subscription/BoltUserVerificationTwoStepsUseCase';
import { IQitafGenerateOtpUseCase } from '../../core/usecases/subscription/QitafGenerateOtpUseCase';
import { IQitafVerifyOtpUseCase } from '../../core/usecases/subscription/QitafVerifyOtpUseCase';
import { IUserRegisterUseCase } from '../../core/usecases/subscription/UserRegisterUseCase';
import { IUserRegisterGeneratePinUseCase } from '../../core/usecases/subscription/UserRegisterGeneratePinUseCase';
import { IUserRegisterVerifyPinUseCase } from '../../core/usecases/subscription/UserRegisterVerifyPinUseCase';
import { IFormSignatureObjectUseCase } from '../../core/usecases/auth/FormSignatureObjectUseCase';
// import { IGetSubscriptionStatusUseCase } from '../../core/usecases/subscription/GetSubscriptionStatusUseCase';
import { IGetSubscriptionStatusUseCase } from '../../core/usecases/UserIdentity/GetSubscriptionStatusUseCase';
import { IQrCodeLinkRequest } from '../../entity/interface/iQrCodes';
import { IQrCodeLinkUseCase } from '../../core/usecases/subscription/QrCodeLinkUseCase';
import { IQitafGenerateOtpPayload, IQitafVerifyOtpPayload } from '../../entity/interface/iEntitlements';
import { ICampaignGenerateUseCase } from '../../core/usecases/subscription/CampaignGenerateUseCase';
import { ICampaignVerifyUseCase } from '../../core/usecases/subscription/CampaignVerifyUseCase';
import { ICheckUserUseCase } from '../../core/usecases/subscription/CheckUserUseCase';
import { IValidateActivationLinkUseCase } from '../../core/usecases/subscription/ValidateActivationLinkUseCase';
import { IDisneyGenerateOtpUseCase } from '../../core/usecases/subscription/DisneyGenerateOtpUseCase';
import { IDisneyValidateOtpUseCase } from '../../core/usecases/subscription/DisneyValidateOtpUseCase';
import { IDisneyRequestActivationLinkUseCase } from '../../core/usecases/subscription/DisneyRequestActivationLinkUseCase';
import { IPartnerActivationRedirectionUseCase } from '../../core/usecases/subscription/PartnerActivationRedirectionUseCase';

export interface ISubscriptionService {
    tpayRedirectSubscribeNew(
        username: string,
        msisdn: string,
        tpay: ITpayPayload,
        reqBody: ITpayRedirectSubscribeNewUserReqBody
    ): Promise<ITpayRedirectSubscribeNewUserEntity>;

    tpayRedirectSubscribeExisting(
        username: string,
        msisdn: string,
        tpay: ITpayPayload,
        reqBody: ITpayRedirectSubscribeExistingUserReqBody
    ): Promise<ITpayRedirectSubscribeExistingUserEntity>;

    unsubscribe(username: string, token: string, reqBody: IUnsubscribeReqBody): Promise<IUnsubscribeEntity>;

    getSubscriptionStatus(
        apiKey: string,
        username: string,
        token: string,
        identityToken: string
    ): Promise<ISubscriptionStatus>;

    boltUserSubscription(payload: IBoltSubscriptionRequest): Promise<IBoltSubscriptionResponse>;

    boltUserSubscriptionTwoSteps(payload: IBoltSubscriptionTwoStepsRequest): Promise<IBoltSubscriptionTwoStepsResponse>;

    boltUserVerificationTwoSteps(payload: IBoltVerifyTwoStepsRequest): Promise<IBoltVerifyTwoStepsResponse>;

    qitafGenerateOtp(
        subType: 'NEW' | 'EXISTING',
        language: string,
        payload: IQitafGenerateOtpPayload,
        identityToken?: string | undefined,
        token?: string | undefined
    ): Promise<any>;

    qitafVerifyOtp(
        subType: 'NEW' | 'EXISTING',
        language: string,
        payload: IQitafVerifyOtpPayload,
        identityToken?: string | undefined,
        token?: string | undefined
    ): Promise<any>;

    userRegister(language: string, payload: IUserRegisterRequest): Promise<any>;

    userRegisterGeneratePin(language: string, payload: IUserRegisterGeneratePin): Promise<any>;

    userRegisterVerifyPin(language: string, payload: IUserRegisterVerifyPin): Promise<any>;

    qrCodeLink(payload: IQrCodeLinkRequest): Promise<boolean>;

    campaignGenerate(username: string, language: string, recaptchaToken?: string): Promise<CampaignGenerateResponse>;

    campaignVerify(username: string, language: string, otp: string): Promise<ICampaignVerifyResponse>;

    checkUser(payload: ICheckUserRequest): Promise<ICheckUserResponse>;
    // checkUser(username: string): Promise<ICheckUserResponse>;

    validateActivationLink(params: IValidateActivationLinkRequest): Promise<IValidateActivationLinkResponse>;

    disneyGenerateOtp(params: IDisneyGenerateOtpRequest): Promise<IDisneyGenerateOtpResponse>;

    disneyValidateOtp(params: IDisneyValidateOtpRequest): Promise<IDisneyValidateOtpResponse>;

    disneyRequestActivationLink(
        params: IDisneyRequestActivationLinkRequest
    ): Promise<IDisneyRequestActivationLinkResponse>;

    partnerActivationRedirection(
        payload: IPartnerActivationRedirectionRequest
    ): Promise<IPartnerActivationRedirectionResponse>;
}

export class SubscriptionService implements ISubscriptionService {
    // Lazy getters for dependencies to avoid circular dependencies
    private get tpayRedirectSubscribeNewUseCase(): ITpayRedirectSubscribeNewUseCase {
        return container.resolve<ITpayRedirectSubscribeNewUseCase>(DI.USECASES.ITpayRedirectSubscribeNewUseCase);
    }

    private get tpayRedirectSubscribeExistingUseCase(): ITpayRedirectSubscribeExistingUseCase {
        return container.resolve<ITpayRedirectSubscribeExistingUseCase>(
            DI.USECASES.ITpayRedirectSubscribeExistingUseCase
        );
    }

    private get unsubscribeUseCase(): IUnsubscribeUseCase {
        return container.resolve<IUnsubscribeUseCase>(DI.USECASES.IUnsubscribeUseCase);
    }

    private get getSubscriptionStatusUseCase(): IGetSubscriptionStatusUseCase {
        return container.resolve<IGetSubscriptionStatusUseCase>(DI.USECASES.IGetSubscriptionStatusUseCase);
    }

    private get boltUserSubscriptionUseCase(): IBoltUserSubscriptionUseCase {
        return container.resolve<IBoltUserSubscriptionUseCase>(DI.USECASES.IBoltUserSubscriptionUseCase);
    }

    private get boltUserSubscriptionTwoStepsUseCase(): IBoltUserSubscriptionTwoStepsUseCase {
        return container.resolve<IBoltUserSubscriptionTwoStepsUseCase>(
            DI.USECASES.IBoltUserSubscriptionTwoStepsUseCase
        );
    }

    private get boltUserVerificationTwoStepsUseCase(): IBoltUserVerificationTwoStepsUseCase {
        return container.resolve<IBoltUserVerificationTwoStepsUseCase>(
            DI.USECASES.IBoltUserVerificationTwoStepsUseCase
        );
    }

    private get qitafGenerateOtpUseCase(): IQitafGenerateOtpUseCase {
        return container.resolve<IQitafGenerateOtpUseCase>(DI.USECASES.ISubscriptionQitafGenerateOtpUseCase);
    }

    private get qitafVerifyOtpUseCase(): IQitafVerifyOtpUseCase {
        return container.resolve<IQitafVerifyOtpUseCase>(DI.USECASES.ISubscriptionQitafVerifyOtpUseCase);
    }

    private get userRegisterUseCase(): IUserRegisterUseCase {
        return container.resolve<IUserRegisterUseCase>(DI.USECASES.IUserRegisterUseCase);
    }

    private get userRegisterGeneratePinUseCase(): IUserRegisterGeneratePinUseCase {
        return container.resolve<IUserRegisterGeneratePinUseCase>(DI.USECASES.IUserRegisterGeneratePinUseCase);
    }

    private get userRegisterVerifyPinUseCase(): IUserRegisterVerifyPinUseCase {
        return container.resolve<IUserRegisterVerifyPinUseCase>(DI.USECASES.IUserRegisterVerifyPinUseCase);
    }

    private get formSignatureObjectUseCase(): IFormSignatureObjectUseCase {
        return container.resolve<IFormSignatureObjectUseCase>(DI.USECASES.IFormSignatureObjectUseCase);
    }

    private get qrCodeLinkUseCase(): IQrCodeLinkUseCase {
        return container.resolve<IQrCodeLinkUseCase>(DI.USECASES.IQrCodeLinkUseCase);
    }

    private get campaignGenerateUseCase(): ICampaignGenerateUseCase {
        return container.resolve<ICampaignGenerateUseCase>(DI.USECASES.ICampaignGenerateUseCase);
    }

    private get campaignVerifyUseCase(): ICampaignVerifyUseCase {
        return container.resolve<ICampaignVerifyUseCase>(DI.USECASES.ICampaignVerifyUseCase);
    }
    private get checkUserUseCase(): ICheckUserUseCase {
        return container.resolve<ICheckUserUseCase>(DI.USECASES.ICheckUserUseCase);
    }

    private get validateActivationLinkUseCase(): IValidateActivationLinkUseCase {
        return container.resolve<IValidateActivationLinkUseCase>(DI.USECASES.IValidateActivationLinkUseCase);
    }

    private get disneyGenerateOtpUseCase(): IDisneyGenerateOtpUseCase {
        return container.resolve<IDisneyGenerateOtpUseCase>(DI.USECASES.IDisneyGenerateOtpUseCase);
    }

    private get disneyValidateOtpUseCase(): IDisneyValidateOtpUseCase {
        return container.resolve<IDisneyValidateOtpUseCase>(DI.USECASES.IDisneyValidateOtpUseCase);
    }

    private get disneyRequestActivationLinkUseCase(): IDisneyRequestActivationLinkUseCase {
        return container.resolve<IDisneyRequestActivationLinkUseCase>(DI.USECASES.IDisneyRequestActivationLinkUseCase);
    }

    private get partnerActivationRedirectionUseCase(): IPartnerActivationRedirectionUseCase {
        return container.resolve<IPartnerActivationRedirectionUseCase>(
            DI.USECASES.IPartnerActivationRedirectionUseCase
        );
    }
    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async tpayRedirectSubscribeNew(
        username: string,
        msisdn: string,
        tpay: ITpayPayload,
        reqBody: ITpayRedirectSubscribeNewUserReqBody
    ): Promise<ITpayRedirectSubscribeNewUserEntity> {
        return await this.tpayRedirectSubscribeNewUseCase.execute(username, msisdn, tpay, reqBody);
    }

    async tpayRedirectSubscribeExisting(
        username: string,
        msisdn: string,
        tpay: ITpayPayload,
        reqBody: ITpayRedirectSubscribeExistingUserReqBody
    ): Promise<ITpayRedirectSubscribeExistingUserEntity> {
        return await this.tpayRedirectSubscribeExistingUseCase.execute(username, msisdn, tpay, reqBody);
    }

    async unsubscribe(username: string, token: string, reqBody: IUnsubscribeReqBody): Promise<IUnsubscribeEntity> {
        return await this.unsubscribeUseCase.execute(username, token, reqBody);
    }

    async getSubscriptionStatus(
        apiKey: string,
        username: string,
        token: string,
        identityToken: string
    ): Promise<ISubscriptionStatus> {
        return await this.getSubscriptionStatusUseCase.execute(apiKey, username, token, identityToken);
    }

    async boltUserSubscription(payload: IBoltSubscriptionRequest): Promise<IBoltSubscriptionResponse> {
        const apiToken = await this.formSignatureObjectUseCase.execute();
        if (!apiToken) {
            throw new Error('Invalid API token');
        }
        return await this.boltUserSubscriptionUseCase.execute(payload, apiToken);
    }

    async boltUserSubscriptionTwoSteps(
        payload: IBoltSubscriptionTwoStepsRequest
    ): Promise<IBoltSubscriptionTwoStepsResponse> {
        const apiToken = await this.formSignatureObjectUseCase.execute();
        if (!apiToken) {
            throw new Error('Invalid API token');
        }
        return await this.boltUserSubscriptionTwoStepsUseCase.execute(payload, apiToken);
    }

    async boltUserVerificationTwoSteps(payload: IBoltVerifyTwoStepsRequest): Promise<IBoltVerifyTwoStepsResponse> {
        const apiToken = await this.formSignatureObjectUseCase.execute();
        if (!apiToken) {
            throw new Error('Invalid API token');
        }
        return await this.boltUserVerificationTwoStepsUseCase.execute(payload, apiToken);
    }

    async qitafGenerateOtp(
        subType: 'NEW' | 'EXISTING',
        language: string,
        payload: IQitafGenerateOtpPayload,
        identityToken?: string | undefined,
        token?: string | undefined
    ): Promise<any> {
        const apiToken = await this.formSignatureObjectUseCase.execute();
        if (!apiToken) {
            throw new Error('Invalid API token');
        }
        return await this.qitafGenerateOtpUseCase.execute(subType, language, payload, apiToken, identityToken, token);
    }

    async qitafVerifyOtp(
        subType: 'NEW' | 'EXISTING',
        language: string,
        payload: IQitafVerifyOtpPayload,
        identityToken?: string | undefined,
        token?: string | undefined
    ): Promise<any> {
        const apiToken = await this.formSignatureObjectUseCase.execute();
        if (!apiToken) {
            throw new Error('Invalid API token');
        }
        return await this.qitafVerifyOtpUseCase.execute(subType, language, payload, apiToken, identityToken, token);
    }

    async userRegister(language: string, payload: IUserRegisterRequest): Promise<any> {
        const apiToken = await this.formSignatureObjectUseCase.execute();
        if (!apiToken) {
            throw new Error('Invalid API token');
        }
        return await this.userRegisterUseCase.execute(language, payload, apiToken);
    }

    async userRegisterGeneratePin(language: string, payload: IUserRegisterGeneratePin): Promise<any> {
        const apiToken = await this.formSignatureObjectUseCase.execute();
        if (!apiToken) {
            throw new Error('Invalid API token');
        }
        return await this.userRegisterGeneratePinUseCase.execute(language, payload, apiToken);
    }

    async userRegisterVerifyPin(language: string, payload: IUserRegisterVerifyPin): Promise<any> {
        const apiToken = await this.formSignatureObjectUseCase.execute();
        if (!apiToken) {
            throw new Error('Invalid API token');
        }
        return await this.userRegisterVerifyPinUseCase.execute(language, payload, apiToken);
    }

    async qrCodeLink(payload: IQrCodeLinkRequest): Promise<boolean> {
        const apiToken = await this.formSignatureObjectUseCase.execute();
        if (!apiToken) {
            throw new Error('Invalid API token');
        }
        return await this.qrCodeLinkUseCase.execute(payload, apiToken);
    }
    async campaignGenerate(username: string, language: string, recaptchaToken?: string): Promise<any> {
        const apiToken = await this.formSignatureObjectUseCase.execute();
        if (!apiToken) {
            throw new Error('Invalid API token');
        }
        return await this.campaignGenerateUseCase.execute(username, language, recaptchaToken, apiToken);
    }

    async campaignVerify(username: string, language: string, otp: string): Promise<ICampaignVerifyResponse> {
        const apiToken = await this.formSignatureObjectUseCase.execute();
        if (!apiToken) {
            throw new Error('Invalid API token');
        }
        return await this.campaignVerifyUseCase.execute(username, language, otp, apiToken);
    }

    async checkUser(payload: ICheckUserRequest): Promise<ICheckUserResponse> {
        const apiToken = await this.formSignatureObjectUseCase.execute();
        if (!apiToken) {
            throw new Error('Invalid API token');
        }
        return await this.checkUserUseCase.execute(payload, apiToken);
    }

    async validateActivationLink(params: IValidateActivationLinkRequest): Promise<IValidateActivationLinkResponse> {
        const apiToken = await this.formSignatureObjectUseCase.execute();
        if (!apiToken) {
            throw new Error('Invalid API token');
        }
        return await this.validateActivationLinkUseCase.execute(params, apiToken);
    }

    async disneyGenerateOtp(params: IDisneyGenerateOtpRequest): Promise<IDisneyGenerateOtpResponse> {
        // Get API token for additional headers if needed
        const apiToken = await this.formSignatureObjectUseCase.execute();
        return await this.disneyGenerateOtpUseCase.execute(params, apiToken || undefined);
    }

    async disneyValidateOtp(params: IDisneyValidateOtpRequest): Promise<IDisneyValidateOtpResponse> {
        // Get API token for additional headers if needed
        const apiToken = await this.formSignatureObjectUseCase.execute();
        return await this.disneyValidateOtpUseCase.execute(params, apiToken || undefined);
    }

    async disneyRequestActivationLink(
        params: IDisneyRequestActivationLinkRequest
    ): Promise<IDisneyRequestActivationLinkResponse> {
        const apiToken = await this.formSignatureObjectUseCase.execute();
        if (!apiToken) {
            throw new Error('Invalid API token');
        }

        return await this.disneyRequestActivationLinkUseCase.execute(params, apiToken);
    }

    async partnerActivationRedirection(
        payload: IPartnerActivationRedirectionRequest
    ): Promise<IPartnerActivationRedirectionResponse> {
        const apiToken = await this.formSignatureObjectUseCase.execute();
        if (!apiToken) {
            throw new Error('Invalid API token');
        }
        return await this.partnerActivationRedirectionUseCase.execute(payload, apiToken);
    }
}
